var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGaming = function SvgGaming(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4471 70.8751H23.2658C21.9533 70.8751 20.9033 69.8251 20.9033 68.5126V9.84386C20.9033 8.40011 22.2158 7.35011 23.5283 7.61261L24.5783 7.74386",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9785 70.875H24.4473",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2094 68.6445C56.0781 69.8258 55.1594 70.7445 53.8469 70.7445C53.8469 70.7445 50.6969 70.7445 49.5156 70.7445",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.71 7.74414L54.3725 12.4691C55.4225 12.6004 56.3412 13.6504 56.3412 14.7004C56.3412 14.7004 56.3412 44.2316 56.3412 49.2191",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.316 70.8751H10.4035C9.09102 70.8751 8.04102 69.8251 8.04102 68.5126V9.84386C8.04102 8.40011 9.35352 7.35011 10.666 7.61261H23.5285",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7531 70.8751C16.4406 70.8751 15.3906 69.8251 15.3906 68.5126V9.84386C15.3906 8.40011 16.7031 7.35011 18.0156 7.61261",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0969 70.8751C15.7844 70.8751 14.7344 69.8251 14.7344 68.5126V9.84386C14.7344 8.40011 16.0469 7.35011 17.3594 7.61261",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0537 77.4375C47.9412 77.4375 51.0912 77.5687 54.11 77.5687L45.0537 77.4375Z",
    fill: "url(#paint0_linear_731_36613)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0537 77.4375C47.9412 77.4375 51.0912 77.5687 54.11 77.5687",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56641 77.3066C16.0477 77.3066 25.6289 77.3066 35.8664 77.3066H8.56641Z",
    fill: "url(#paint1_linear_731_36613)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56641 77.3066C16.0477 77.3066 25.6289 77.3066 35.8664 77.3066",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9727 76.9121C48.3352 77.1746 50.9602 77.3059 54.1102 77.4371",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56641 77.3063C15.6539 77.0438 23.3977 76.125 32.4539 75.4688C33.2414 75.6 34.0289 75.6 34.6852 75.7313",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.241 73.5L34.1598 75.8625H25.7598V70.875H32.716L33.241 73.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0162 55.5187C39.8037 52.7625 42.1662 50.6625 46.6287 50.1375C54.2412 49.35 60.0162 49.35 66.8412 50.1375C71.0412 50.6625 73.01 53.025 73.7975 55.2563L78.9162 69.5625C80.0975 73.1062 78.3912 76.9125 74.8475 78.0937C71.3037 79.275 67.235 77.5687 65.9225 74.025C65.135 71.6625 63.035 68.3813 60.41 68.3813H53.4537C50.96 68.3813 48.2037 71.5313 47.285 74.025C46.1037 77.5687 41.6412 79.4062 38.0975 78.0937C34.5537 76.9125 32.7162 72.975 34.0287 69.5625L39.0162 55.5187Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4977 56.175C67.2352 56.3062 66.9727 56.4375 66.7102 56.4375C66.1852 56.4375 65.6602 55.9125 65.6602 55.3875C65.6602 54.8625 66.1852 54.4688 66.7102 54.4688C67.2352 54.4688 67.7602 54.9937 67.7602 55.5187C67.8914 55.7812 67.7602 56.0437 67.4977 56.175Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1163 38.7184C40.8538 38.9809 40.5913 39.1121 40.3288 38.9809C39.8038 38.8496 39.2788 38.0621 39.41 37.2746C39.41 36.4871 39.935 35.8309 40.5913 35.9621C41.2475 36.0934 41.6413 36.8809 41.5101 37.6684C41.5101 38.1934 41.3788 38.5871 41.1163 38.7184Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.516 59.85C70.3848 59.85 70.2535 59.85 70.1223 59.85C69.5973 59.85 69.0723 59.325 69.0723 58.6688C69.0723 58.1438 69.5973 57.75 70.2535 57.75C70.9098 57.75 71.3035 58.275 71.3035 58.9313C71.1723 59.4563 70.9098 59.7188 70.516 59.85Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.56 59.85C63.4287 59.85 63.2975 59.85 63.1662 59.85C62.6412 59.85 62.1162 59.325 62.1162 58.6688C62.1162 58.1438 62.6412 57.75 63.2975 57.75C63.8225 57.75 64.3475 58.275 64.3475 58.9313C64.2162 59.4563 63.9537 59.7188 63.56 59.85Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9224 61.687C66.1849 61.4245 66.4474 61.2933 66.8412 61.4245C67.3662 61.5558 67.8912 62.0808 67.7599 62.6058C67.7599 63.1308 67.2349 63.5245 66.5787 63.5245C65.9224 63.5245 65.5287 62.8683 65.6599 62.3433C65.7912 61.9495 65.7912 61.8183 65.9224 61.687Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4787 56.5684H49.385C50.3037 56.5684 51.0912 57.3559 51.0912 58.2746C51.0912 59.1934 50.3037 59.9809 49.385 59.9809H43.4787C42.56 59.9809 41.7725 59.1934 41.7725 58.2746C41.7725 57.3559 42.56 56.5684 43.4787 56.5684Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2659 60.8995L45.3159 55.1245C45.4471 54.2058 46.3659 53.5495 47.2846 53.6808C48.2034 53.812 48.8596 54.7308 48.7284 55.6495L47.6784 61.4245C47.5471 62.3433 46.6284 62.9995 45.7096 62.8683C44.6596 62.737 44.0034 61.9495 44.2659 60.8995Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.616 51.4488C69.3348 49.3488 67.7598 49.0863 63.9535 49.2175L63.8223 50.005C67.1035 50.1363 68.8098 50.1363 72.3535 52.63L72.616 51.4488Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6729 51.4488C42.9541 49.3488 44.5291 49.0863 48.3354 49.2175L48.4666 50.005C45.1854 50.1363 43.4791 50.1363 39.9354 52.63L39.6729 51.4488Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1598 64.3125H57.916C58.1785 64.3125 58.441 64.575 58.441 64.8375C58.441 65.1 58.1785 65.3625 57.916 65.3625H55.1598C54.8973 65.3625 54.6348 65.1 54.6348 64.8375C54.6348 64.4438 54.8973 64.3125 55.1598 64.3125Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7661 71.9238C33.5036 74.5488 35.3411 76.6488 38.2286 77.4363C40.7223 78.0926 43.7411 78.0926 46.2348 75.4676",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9166 71.4004C79.3104 74.0254 77.6041 76.2566 74.7166 77.0441C72.2229 77.8316 69.2041 77.9629 66.5791 75.3379",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_731_36613",
    x1: 45.0179,
    y1: 77.4561,
    x2: 54.1109,
    y2: 77.4561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_731_36613",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGaming);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "gaming.9156c8a6c8de13ed8784422b07674e18.svg";